import * as yup from "yup";
import "./VacatingTenantList.css";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import CryptoJS from "crypto-js";
import {convertFromRaw, EditorState} from "draft-js";
import {styled} from "@mui/material/styles";
import {TextField} from "@material-ui/core";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Alert from "@mui/material/Alert";
import Divider from "@mui/material/Divider";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import {DataGrid} from "@mui/x-data-grid";
import CardContent from "@mui/material/CardContent";
import InputAdornment from "@mui/material/InputAdornment";
import LoadingButton from "@mui/lab/LoadingButton";
import {TransitionProps} from "@mui/material/transitions";
import Slide from "@mui/material/Slide";
import SendIcon from "@mui/icons-material/Send";
import SearchIcon from "@mui/icons-material/Search";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CalculateIcon from '@mui/icons-material/Calculate';
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';
import PersonIcon from '@mui/icons-material/Person';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import {
    WarningAmberOutlined,
    Restore,
    CheckCircleOutlineOutlined,
    HomeWorkOutlined,
    EventNoteOutlined,
    DescriptionOutlined,
    ArrowBackIosNewOutlined
} from "@mui/icons-material";

import RefreshIcon from '@mui/icons-material/Refresh';
import DeleteIcon from '@mui/icons-material/Delete';
import InputBase from '@mui/material/InputBase';
import {ErrorMessage, Field, Form, Formik} from "formik";
import NonEditableRichTextEditor from "../../components/RichTextEditorNotEditable/NonEditableRichTextEditor";
import {ApiDetails, KEY} from "../../Constants";
import { handle401Unauthorized, handle403Forbidden } from '../../utils/authErrorHandler';

const StyledDataGrid = styled(DataGrid)(({theme}) => ({
    "& .MuiDataGrid-columnHeaders": {
        fontSize: "0.95rem",
        fontWeight: 600,
        backgroundColor: "#f0f4f8", // Lighter blue background
        color: "#2c3e50", // Darker text for better contrast
        borderBottom: "2px solid #e0e0e0",
    },
    "& .MuiDataGrid-row": {
        borderBottom: "1px solid #f5f5f5",
        "&:nth-of-type(even)": {
            backgroundColor: "#fafafa",
        },
    },
    "& .MuiDataGrid-row:hover": {
        backgroundColor: "#f5f8fa", // Subtle hover color
        transition: "background-color 0.2s ease",
    },
    "& .MuiDataGrid-cell:focus": {
        outline: "none",
    },
    "& .MuiDataGrid-cell": {
        fontSize: "0.9rem",
        color: "#34495e", // Slightly lighter than header text
        padding: "16px 8px",
    },
    "& .notice-row": {
        backgroundColor: "#fff8e1", // Light amber background for notice rows
    },
    "& .MuiDataGrid-columnSeparator": {
        display: "none",
    },
    "& .MuiDataGrid-footerContainer": {
        borderTop: "1px solid #e0e0e0",
        backgroundColor: "#f9fafb",
    },
}));

const SearchBox = styled(Paper)(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '2px 8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
}));

const PageHeader = styled(Box)(({theme}) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
}));

const StyledCard = styled(Card)(({theme}) => ({
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
}));

const StyledCardContent = styled(CardContent)(({theme}) => ({
    padding: '16px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
}));

const StyledDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialog-paper': {
        borderRadius: '12px',
        overflow: 'hidden',
    },
    '& .MuiDialogTitle-root': {
        padding: '20px 24px',
        borderBottom: '1px solid #e0e0e0',
        backgroundColor: '#f8f9fa',
    },
    '& .MuiDialogContent-root': {
        padding: '24px',
    },
    '& .MuiDialogActions-root': {
        padding: '16px 24px',
        borderTop: '1px solid #e0e0e0',
    },
}));

const DialogHeaderStyled = styled(DialogTitle)(({theme, error}) => ({
    color: error ? '#e74c3c' : '#2c3e50',
    fontWeight: 600,
    fontSize: '1.25rem',
    textAlign: 'center',
}));

const SummaryCard = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'bgColor' && prop !== 'textColor',
})(({theme, bgColor, textColor}) => ({
    backgroundColor: bgColor || '#e3f2fd',
    color: textColor || '#1976d2',
    borderRadius: '12px',
    padding: '16px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    height: '100%',
}));

const FormField = styled(Box)(({theme}) => ({
    marginBottom: '16px',
}));

// Transition Component for Dialog
const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>,
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function VacatingTenantList(props) {
    const navigate = useNavigate();

    // Decrypt localStorage data
    let myMapDetailsDecrypted = CryptoJS.AES.decrypt(
        localStorage.getItem("myMap"),
        KEY
    );

    let originalText = myMapDetailsDecrypted.toString(CryptoJS.enc.Utf8);

    // State variables
    const [backDrop, setBackDrop] = useState(
        <Backdrop
            sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
            open={true}
            onClick={null}
        >
            <CircularProgress color="inherit"/>
        </Backdrop>
    );

    const [dataSet, setDataSet] = useState(false);
    let [tenants, updateTenants] = React.useState([]);
    const [searchResults, setSearchResults] = useState([]);
    let [, updateProperties] = React.useState([]);
    const [expensesIncurred, setExpensesIncurred] = useState(1);
    const [expenses, setExpenses] = useState([]);
    const [expenseItem] = useState(new Map());
    const [totalExpenses, setTotalExpenses] = useState(0);
    const [depositToRefund, setDepositToRefund] = useState(0);
    const [lossIncurred, setLossIncurred] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const [refreshing, setRefreshing] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [refundModal, setRefundModal] = useState(false);
    const [moreInfoModal, setMoreInfoModal] = useState(false);
    const [addDepositExpenseModal, setAddDepositExpenseModal] = useState(false);
    const [vacatingModal, setVacatingModal] = useState(false);
    const [loading, setLoading] = React.useState(false);
    const [tenantLoading, setTenantLoading] = React.useState(false);
    const [tenantDetails, setTenantDetails] = useState({
        tenant_id: "",
        tenant_name: "",
        deposit_held: "",
        phone_number: "",
        secondary_phone_number: "",
    });

    const [noticeDetails, setNoticeDetails] = useState({
        last_name: "",
        first_name: "",
        date_created: "",
        deposit_held: "",
        date_to_vacate_house: "",
        reasons_for_vacating: "",
    });

    const [restoreTenantDetails, setRestoreTenantDetails] = useState({
        property_id: "",
        tenant_id: "",
        house_number: "",
        name: "",
    });

    // Form state
    const [initialPaymentsDetails, setInitialPaymentsDetails] = useState(false);
    const [initialPaymentValues, setInitialPaymentValues] = useState({
        names: "",
        amount: "",
        deposit: "",
        expenses: "",
        tenant_id: "",
        phone_number: "",
        property_id: "",
        house_number: "",
        account_number: "",
        secondary_phone_number: "",
    });

    // Input states
    const [inputs, setInputs] = useState(
        <div>
            <br/>
            <div
                style={{
                    display: "none",
                    justifyContent: "space-between",
                }}
            >
                <TextField
                    label="Description"
                    type={"text"}
                    variant="outlined"
                    required
                    style={{marginTop: "10px", width: "49%"}}
                />
                <TextField
                    label="Amount"
                    type={"number"}
                    variant="outlined"
                    style={{marginTop: "10px", width: "49%"}}
                />
            </div>
        </div>
    );

    const [depositExpenses, setDepositExpenses] = useState(
        <div>
            <br/>
            <div
                style={{
                    display: "none",
                    justifyContent: "space-between",
                }}
            >
                <TextField
                    label="Description"
                    type={"text"}
                    variant="outlined"
                    required
                    style={{marginTop: "10px", width: "49%"}}
                />
                <TextField
                    label="Amount"
                    type={"number"}
                    variant="outlined"
                    style={{marginTop: "10px", width: "49%"}}
                />
            </div>
        </div>
    );

    // Validation schema
    const basicSchema = yup.object().shape({
        phone_number: yup
            .string()
            .required("Phone number is required")
            .matches(
                /^(?:254|\+254|0)?(7[0-9]{8}|1[0-9]{8})$/,
                "Please enter a valid Kenyan phone number (e.g., 0712345678, 254712345678, or +254712345678)"
            )
            .test(
                'is-valid-kenyan',
                'Must be a valid Kenyan mobile number starting with 07, 01, +2547, or +2541',
                function (value) {
                    if (!value) return true; // Skip if empty (required handles this)

                    // Format the number to standard format
                    let normalized = value;

                    // Remove any non-digit characters
                    normalized = normalized.replace(/\D/g, '');

                    // Check if it starts with 0 and convert to international format
                    if (normalized.startsWith('0')) {
                        normalized = '254' + normalized.substring(1);
                    }

                    // Check if it has the correct length and prefix
                    return (
                        (normalized.startsWith('2547') || normalized.startsWith('2541')) &&
                        normalized.length === 12
                    );
                }
            ),
        amount: yup.number().min(0, "Amount can't be lower than 0"),
    });

    // UseEffect to fetch data
    useEffect(() => {
        props.refreshSideBar();
        fetchVacatingTenants();
    }, []);

    // Handle search input change
    const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchTerm(value);

        if (value === '') {
            setSearchResults(tenants);
            return;
        }

        const filtered = tenants.filter(tenant =>
            (tenant.first_name + ' ' + tenant.last_name).toLowerCase().includes(value) ||
            tenant.house_number.toLowerCase().includes(value) ||
            tenant.property_name.toLowerCase().includes(value)
        );

        setSearchResults(filtered);
    };

    const handleChange = (props) => (event) => {
        // console.log("Target event name : " + event.target.name);
        expenseItem.set(event.target.name, event.target.value);
        setExpenses([...expenses, expenseItem]);
        // expenseItem.clear();

    };

    // Handle expense change
    /*
        const handleChange = () => (event) => {
            // Create a copy of the existing expenseItem map
            const updatedMap = new Map(expenseItem);

            // Update the copied map with the new value
            updatedMap.set(event.target.name, event.target.value);

            // Replace the old map with the updated one
            expenseItem.clear();
            updatedMap.forEach((value, key) => {
                expenseItem.set(key, value);
            });

            // Update the expenses state with the updated map
            if (expenses.length > 0) {
                // If we already have expenses, update the first one (assuming we're using one map)
                const newExpenses = [...expenses];
                newExpenses[0] = expenseItem;
                setExpenses(newExpenses);
            } else {
                // If no expenses yet, add this as the first one
                setExpenses([expenseItem]);
            }
        };
    */


    // Restore tenant
    const restoreTenant = () => {
        setLoading(true);
        fetch(ApiDetails + "pegasus/visionary/tenant/restore", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]
            },
            body: JSON.stringify({
                property_id: restoreTenantDetails.property_id,
                tenant_id: restoreTenantDetails.tenant_id,
                house_number: restoreTenantDetails.house_number,
            }),
        })
            .then(async (response) => {
                // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
                if (response.status === 200) {
                    props.snackBar({
                        text: "Tenant restored successfully",
                        type: "success",
                    });
                    handleClose();
                    fetchVacatingTenants();
                } else if (response.status === 403) {
                    props.snackBar({
                        text: "Unit is currently occupied by another tenant",
                        type: "error",
                    });
                    handleClose();
                    fetchVacatingTenants();
                } else {
                    props.snackBar({
                        text: "Something went wrong, please try again later",
                        type: "error",
                    });
                    setLoading(false);
                }
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
                props.snackBar({
                    text: "Failed connecting to server",
                    type: "error",
                });
            });
    };

    // Close modals
    const handleClose = () => {
        setDataSet(false);
        setDeleteModal(false);
        setRefundModal(false);
        setMoreInfoModal(false);
        setVacatingModal(false);
        setAddDepositExpenseModal(false);
    };

    // Calculate refundable deposit
    /*
        const calculateRefundableDeposit = () => {
            try {
                // Fix: Check if expenses array has items before accessing
                if (!expenses.length || !expenses[0]) {
                    props.snackBar({
                        text: "Please add at least one expense",
                        type: "error",
                    });
                    return;
                }

                let issueExpenses = new Map(expenses[0]);
                let sortedMap = new Map();
                let expense = 0;

                issueExpenses.forEach(function (value, key) {
                    let newKey = value;
                    let includes = key;
                    if (!key.includes("value")) {
                        issueExpenses.forEach(function (value, key) {
                            if (key.includes(includes)) {
                                sortedMap.set(newKey, value);
                            }
                        });
                    }
                });

                sortedMap.forEach(function (value, key) {
                    // Fix: Handle non-numeric inputs
                    const numValue = parseFloat(value) || 0;
                    expense = parseFloat(expense) + numValue;
                });

                setTotalExpenses(
                    expense.toLocaleString("en-US", {
                        style: "currency",
                        currency: "KSH",
                    })
                );

                // Fix: Handle non-numeric deposit held
                const depositHeld = parseFloat(tenantDetails.deposit_held.replace(/,/g, '')) || 0;
                let depositToRefund = depositHeld - expense;

                if (depositToRefund >= 0) {
                    setDepositToRefund(depositToRefund);
                    setLossIncurred(0); // Reset loss incurred
                } else {
                    setDepositToRefund(0);
                    setLossIncurred(Math.abs(depositToRefund));
                }
            } catch (error) {
                console.error("Error calculating deposit:", error);
                props.snackBar({
                    text: "Error calculating deposit: " + error.message,
                    type: "error",
                });
            }

        };
    */

// Replace this function
    const calculateRefundableDeposit = () => {
        try {
            // Safety check
            if (!expenses.length) {
                props.snackBar({
                    text: "Please add at least one expense",
                    type: "error",
                });
                return;
            }

            // Get all expense maps (could be multiple in the array)
            let totalExpense = 0;

            // First, log what we actually have in the expenses array
            console.log("All expenses:", expenses);

            // Loop through all maps in the expenses array
            expenses.forEach((expMap, index) => {
                // Make sure it's a Map
                if (expMap instanceof Map && index === 0) {
                    expMap.forEach((value, key) => {
                        // Only process the amount fields
                        if (key.includes("value for description")) {
                            const amount = parseFloat(value) || 0;
                            console.log(`Expense ${index}, ${key}: ${amount}`);
                            totalExpense += amount;
                        }
                    });
                }
            });

            console.log("Total expense calculated:", totalExpense);

            // Format for display
            setTotalExpenses(
                totalExpense.toLocaleString("en-US", {
                    style: "currency",
                    currency: "KSH",
                })
            );

            // Calculate refundable amount
            const depositHeld = parseFloat(tenantDetails.deposit_held.toString().replace(/,/g, '')) || 0;
            const refundAmount = Math.max(0, depositHeld - totalExpense);

            setDepositToRefund(refundAmount);
            setLossIncurred(refundAmount === 0 ? Math.abs(depositHeld - totalExpense) : 0);
        } catch (error) {
            console.error("Error calculating deposit:", error);
            props.snackBar({
                text: "Error calculating deposit: " + error.message,
                type: "error",
            });
        }
    };
    // Handle refund deposit
    const handleRefundDeposit = () => {
        try {
            // Fix: Check if expenses array has items before accessing
            if (!expenses.length || !expenses[0]) {
                props.snackBar({
                    text: "Please add at least one expense",
                    type: "error",
                });
                return;
            }

            let issueExpenses = new Map(expenses[0]);
            let sortedMap = new Map();

            issueExpenses.forEach(function (value, key) {
                let newKey = value;
                let includes = key;
                if (!key.includes("value")) {
                    issueExpenses.forEach(function (value, key) {
                        if (key.includes(includes)) {
                            sortedMap.set(newKey, value);
                        }
                    });
                }
            });

            setLoading(true);

            // Make API call to update tenant deposit
            fetch(ApiDetails + "pegasus/visionary/tenant/vacating/tenants/deposit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]
                },
                body: JSON.stringify({
                    ...Object.fromEntries(sortedMap),
                    tenant_id: tenantDetails.tenant_id,
                    deposit_to_refund: depositToRefund,
                }),
            })
                .then(async (response) => {
                    // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
                    if (response.status === 200) {
                        fetchVacatingTenants();
                        props.snackBar({
                            text: "Tenant Deposit Details Updated Successfully",
                            type: "success",
                        });
                        handleClose();
                    } else if (response.status === 500) {
                        props.snackBar({
                            text: "Something went wrong. Please try again later.",
                            type: "error",
                        });
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                    setLoading(false);
                    props.snackBar({
                        text: "Something Went Wrong. Try Again Later",
                        type: "error",
                    });
                });
        } catch (error) {
            console.error("Error handling refund:", error);
            setLoading(false);
            props.snackBar({
                text: "Error processing refund: " + error.message,
                type: "error",
            });
        }

    };

    // Process payment
    const processPayment = (values) => {
        setTenantLoading(true);

        try {
            // Fix: Handle non-numeric inputs
            let deposit = parseFloat(values.deposit_held.replace(/,/g, '')) || 0;
            let totalExpenses = 0;

            // Fix: Ensure expenses is an object that can be iterated
            const expensesObj = values.expenses || {};

            new Map(Object.entries(expensesObj)).forEach((expense) => {
                totalExpenses = totalExpenses + (parseFloat(expense) || 0);
            });

            let indicator = deposit - totalExpenses;
            let status = indicator > 0 ? "REFUNDED" : indicator === 0 ? "NEUTRAL" : "LOSS";

            let body = {
                ...values,
                status: status,
                indicator: indicator,
                landlord_id: JSON.parse(originalText)[0][1],
            };

            fetch(ApiDetails + "pegasus/visionary/tenant/handle/deposit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]
                },
                body: JSON.stringify(body),
            })
                .then(async (response) => {
                    // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
                    if (response.status === 200) {
                        props.snackBar({
                            text: "Payment processed successfully",
                            type: "success",
                        });
                        fetchVacatingTenants();
                        handleClose();
                    } else {
                        props.snackBar({
                            text: "Failed processing payment",
                            type: "error",
                        });
                    }
                    setTenantLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                    props.snackBar({
                        text: "Something went wrong. Try again later",
                        type: "error",
                    });
                    setTenantLoading(false);
                });
        } catch (error) {
            console.error("Error processing payment:", error);
            setTenantLoading(false);
            props.snackBar({
                text: "Error processing payment: " + error.message,
                type: "error",
            });
        }
    };

    // Process deposit as income
    const processDepositAsIncome = (values) => {
        setTenantLoading(true);

        try {
            let body = {
                ...values,
                landlord_id: JSON.parse(originalText)[0][1],
            };

            fetch(ApiDetails + "pegasus/visionary/tenant/deposit/income", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]
                },
                body: JSON.stringify(body),
            })
                .then(async (response) => {
                    // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
                    if (response.status === 200) {
                        props.snackBar({
                            text: "Deposit processed as income successfully",
                            type: "success",
                        });
                        fetchVacatingTenants();
                        handleClose();
                    } else {
                        props.snackBar({
                            text: "Failed processing deposit as income",
                            type: "error",
                        });
                    }
                    setTenantLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                    props.snackBar({
                        text: "Something went wrong. Try again later",
                        type: "error",
                    });
                    setTenantLoading(false);
                });
        } catch (error) {
            console.error("Error processing deposit as income:", error);
            setTenantLoading(false);
            props.snackBar({
                text: "Error processing deposit as income: " + error.message,
                type: "error",
            });
        }
    };

    // Data Grid Columns
// Icons that need to be imported
// Function to fetch vacating tenants
    const fetchVacatingTenants = () => {
        setRefreshing(true);
        fetch(ApiDetails + "pegasus/visionary/tenant/vacating/tenants", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]
            },
            body: JSON.stringify({
                landlord_id: JSON.parse(originalText)[0][1],
            }),
        })
            .then(async (response) => {
                let tenants = await response.json();

                // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
                if (response.status === 200) {
                    // Get All Properties
                    fetch(ApiDetails + "pegasus/visionary/property/get/all/properties", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "token": JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]
                        },
                        body: JSON.stringify({
                            landlord_id: JSON.parse(originalText)[0][1],
                        }),
                    })
                        .then(async (response) => {
                            let data = await response.json();

                            // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
                            if (response.status === 200) {
                                updateProperties(data);
                                updateTenants(tenants);
                                setSearchResults(tenants);
                                setBackDrop(<></>);
                                setRefreshing(false);
                            } else {
                                props.snackBar({
                                    text: "Failed Fetching Property Details",
                                    type: "error",
                                });
                                setRefreshing(false);
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                            setRefreshing(false);
                            props.snackBar({
                                text: "Failed connecting to server",
                                type: "error",
                            });
                        });
                } else {
                    props.snackBar({text: "Failed Fetching Tenant Details", type: "error"});
                    setRefreshing(false);
                }
            })
            .catch((err) => {
                console.log(err);
                setRefreshing(false);
                props.snackBar({
                    text: "Failed connecting to server",
                    type: "error",
                });
            });
    };

// ExpenseRow component for rendering expense inputs
    const ExpenseRow = styled(Box)(({theme}) => ({
        display: 'flex',
        gap: '16px',
        marginBottom: '16px',
    }));

    // Helper to get numeric value from potentially empty string
    const getNumericValue = (value) => {
        if (value === '' || value === null || value === undefined) return 0;
        return parseFloat(value) || 0;
    };

    // Check if deposit_to_refund has been set (not empty string)
    const hasDepositToRefund = (value) => {
        return value !== '' && value !== null && value !== undefined;
    };

// Statistics calculators
    const totalTenants = searchResults.length;
    const tenantsWithRefundableDeposit = searchResults.filter(tenant => hasDepositToRefund(tenant.deposit_to_refund)).length;
    const tenantsWithoutRefundableDeposit = searchResults.filter(tenant => !hasDepositToRefund(tenant.deposit_to_refund)).length;

// Calculate total deposit held and to refund
    const totalDepositHeld = searchResults.reduce((total, tenant) => {
        const depositHeld = getNumericValue(tenant.deposit_held);
        return total + depositHeld;
    }, 0);

    const totalDepositToRefund = searchResults.reduce((total, tenant) => {
        if (!hasDepositToRefund(tenant.deposit_to_refund)) return total;
        const depositToRefund = getNumericValue(tenant.deposit_to_refund);
        return total + depositToRefund;
    }, 0);


    // Replace the current expense handling with this:
    const handleAddInitialExpense = (arrears) => {
        // Clear previous expenses
        const newExpenseItem = new Map();
        newExpenseItem.set("description 1", "Arrears");
        newExpenseItem.set("value for description 1", arrears);

        // Set as a single item in the expenses array
        setExpenses([newExpenseItem]);

        // Update UI
        setInputs(
            <ExpenseRow>
                <TextField
                    label="Description"
                    type="text"
                    variant="outlined"
                    name="description 1"
                    defaultValue="Arrears"
                    fullWidth
                    InputLabelProps={{shrink: true}}
                    onChange={handleChange("property1")}
                />
                <TextField
                    label="Amount"
                    type="number"
                    variant="outlined"
                    name="value for description 1"
                    defaultValue={arrears}
                    fullWidth
                    InputLabelProps={{shrink: true}}
                    onChange={handleChange("property1")}
                />
            </ExpenseRow>
        );
    };


    // Add this function to calculate refundable amount
    const calculateRefundableAmount = (depositHeld, expenses) => {
        // Parse deposit held - handle both string and number inputs
        const depositStr = String(depositHeld || 0);
        const deposit = parseFloat(depositStr.replace(/,/g, '')) || 0;

        // Calculate total expenses
        let totalExpenses = 0;
        if (expenses && typeof expenses === 'object') {
            Object.values(expenses).forEach(value => {
                totalExpenses += parseFloat(value) || 0;
            });
        }

        // Calculate refundable amount (minimum 0)
        // return Math.max(0, deposit - totalExpenses);
        return (deposit - totalExpenses);
    };

    // Format currency helper
    const formatCurrency = (amount) => {
        const value = parseFloat(amount) || 0;
        return value.toLocaleString("en-KE", {
            style: "currency",
            currency: "KES",
        });
    };

    // Format date - handles ISO strings and pre-formatted dates
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';

        // If it's already a formatted string like "February 01, 2026", return as-is
        if (typeof dateString === 'string' && !dateString.includes('T') && !dateString.includes('-')) {
            return dateString;
        }

        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString;

            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: '2-digit'
            });
        } catch (e) {
            return dateString;
        }
    };

    // Parse deposit_expenses XML string to extract expenses
    const parseDepositExpensesXml = (xmlString) => {
        if (!xmlString || xmlString === '') return [];

        try {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xmlString, "text/xml");
            const expElements = xmlDoc.getElementsByTagName("EXP");
            const expenses = [];

            for (let i = 0; i < expElements.length; i++) {
                const descElement = expElements[i].getElementsByTagName("DESCRIPTION")[0];
                const amountElement = expElements[i].getElementsByTagName("AMOUNT")[0];

                if (descElement && amountElement) {
                    expenses.push({
                        description: descElement.textContent || '',
                        amount: parseFloat(amountElement.textContent) || 0
                    });
                }
            }

            return expenses;
        } catch (e) {
            console.error("Error parsing deposit expenses XML:", e);
            return [];
        }
    };

// Column definition
    const columns = [
        {
            field: "user",
            headerName: "Tenant",
            minWidth: 220,
            flex: 1,
            renderCell: (params) => {
                return (
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        height: "100%",
                        padding: "8px 0"
                    }}>
                        <Box sx={{mr: 2}}>
                            {params.row.state === "NOTICE" ? (
                                <Avatar sx={{bgcolor: "#fff3e0"}}>
                                    <WarningAmberOutlined sx={{color: "#f57c00"}}/>
                                </Avatar>
                            ) : (
                                <Avatar sx={{bgcolor: "#e8f5e9"}}>
                                    <CheckCircleOutlineOutlined sx={{color: "#4caf50"}}/>
                                </Avatar>
                            )}
                        </Box>
                        <Box>
                            <Typography variant="body1" sx={{fontWeight: 500}}>
                                {params.row.first_name} {params.row.last_name}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                {params.row.phone_number}
                            </Typography>
                        </Box>
                    </Box>
                );
            },
        },
        {
            field: "property_name",
            headerName: "Property",
            minWidth: 180,
            flex: 1,
            renderCell: (params) => (
                <Box sx={{display: "flex", alignItems: "center"}}>
                    <HomeWorkOutlined sx={{color: "#607d8b", mr: 1, fontSize: "1.1rem"}}/>
                    <Typography variant="body2">{params.value}</Typography>
                </Box>
            ),
        },
        {
            field: "house_number",
            headerName: "House No.",
            minWidth: 120,
            flex: 0.7,
            renderCell: (params) => (
                <Chip
                    label={params.value}
                    size="small"
                    sx={{
                        bgcolor: '#e3f2fd',
                        color: '#1976d2',
                        fontWeight: 500
                    }}
                />
            ),
        },
        {
            field: "total_outstanding",
            headerName: "Outstanding",
            minWidth: 120,
            flex: 0.8,
            renderCell: (params) => {
                const totalOutstanding = getNumericValue(params.row.total_outstanding);

                return (
                    <Typography
                        variant="body2"
                        sx={{
                            color: totalOutstanding === 0 ? "#4caf50" : "#f44336",
                            fontWeight: 600
                        }}
                    >
                        {formatCurrency(totalOutstanding)}
                    </Typography>
                );
            },
        },
        {
            field: "total_overpayment",
            headerName: "Credit",
            minWidth: 110,
            flex: 0.7,
            renderCell: (params) => {
                const overpayment = getNumericValue(params.row.total_overpayment);

                if (overpayment > 0) {
                    return (
                        <Typography variant="body2" sx={{fontWeight: 600, color: "#4caf50"}}>
                            +{formatCurrency(overpayment)}
                        </Typography>
                    );
                }
                return (
                    <Typography variant="body2" color="text.secondary">
                        -
                    </Typography>
                );
            },
        },
        {
            field: "deposit_held",
            headerName: "Deposit",
            minWidth: 120,
            flex: 0.8,
            renderCell: (params) => {
                const deposit = getNumericValue(params.row.deposit_held);

                return (
                    <Typography variant="body2" sx={{fontWeight: 600, color: "#2196f3"}}>
                        {formatCurrency(deposit)}
                    </Typography>
                );
            },
        },
        {
            field: "deposit_to_refund",
            headerName: "Refund / Owed",
            minWidth: 140,
            flex: 0.9,
            renderCell: (params) => {
                const isNoRefund = params.row.settlement_recommendation === 'NO_REFUND';
                const amountOwed = getNumericValue(params.row.amount_owed);
                const potentialRefund = getNumericValue(params.row.potential_refund);
                const overpayment = getNumericValue(params.row.total_overpayment);

                // If deposit_to_refund is set, use it
                if (hasDepositToRefund(params.row.deposit_to_refund)) {
                    const refundableDeposit = getNumericValue(params.row.deposit_to_refund);
                    return (
                        <Box>
                            <Typography variant="body2" sx={{fontWeight: 600, color: "#4caf50"}}>
                                {formatCurrency(refundableDeposit)}
                            </Typography>
                            {overpayment > 0 && (
                                <Typography variant="caption" color="textSecondary">
                                    (incl. credit)
                                </Typography>
                            )}
                        </Box>
                    );
                }

                // Check if NO_REFUND with amount owed
                if (isNoRefund && amountOwed > 0) {
                    return (
                        <Box>
                            <Typography variant="body2" sx={{fontWeight: 600, color: "#f44336"}}>
                                Owes: {formatCurrency(amountOwed)}
                            </Typography>
                        </Box>
                    );
                }

                // Show potential refund if available (e.g., FULL_REFUND_PLUS_CREDIT)
                if (potentialRefund > 0) {
                    return (
                        <Box>
                            <Typography variant="body2" sx={{fontWeight: 600, color: "#4caf50"}}>
                                {formatCurrency(potentialRefund)}
                            </Typography>
                            {overpayment > 0 && (
                                <Typography variant="caption" color="textSecondary">
                                    (incl. credit)
                                </Typography>
                            )}
                        </Box>
                    );
                }

                return (
                    <Chip
                        label="Not Set"
                        size="small"
                        variant="outlined"
                        color="warning"
                    />
                );
            },
        },
        {
            field: "settlement_recommendation",
            headerName: "Status",
            minWidth: 140,
            flex: 0.9,
            renderCell: (params) => {
                const recommendation = params.row.settlement_recommendation;

                switch (recommendation) {
                    case 'FULL_REFUND_PLUS_CREDIT':
                        return (
                            <Tooltip title={params.row.settlement_message || "Full refund plus credit"}>
                                <Chip
                                    label="Full + Credit"
                                    size="small"
                                    sx={{bgcolor: '#4caf50', color: 'white'}}
                                />
                            </Tooltip>
                        );
                    case 'FULL_REFUND':
                        return (
                            <Tooltip title={params.row.settlement_message || "Full refund"}>
                                <Chip label="Full Refund" size="small" color="success" />
                            </Tooltip>
                        );
                    case 'PARTIAL_REFUND':
                        return (
                            <Tooltip title={params.row.settlement_message || "Partial refund"}>
                                <Chip label="Partial" size="small" color="warning" />
                            </Tooltip>
                        );
                    case 'NO_REFUND':
                        return (
                            <Tooltip title={params.row.settlement_message || "No refund"}>
                                <Chip label="No Refund" size="small" color="error" />
                            </Tooltip>
                        );
                    case 'NO_DEPOSIT':
                        return (
                            <Tooltip title={params.row.settlement_message || "No deposit held"}>
                                <Chip label="No Deposit" size="small" variant="outlined" />
                            </Tooltip>
                        );
                    default:
                        return (
                            <Chip label="Pending" size="small" variant="outlined" color="default" />
                        );
                }
            },
        },
        {
            field: "action",
            headerName: "Actions",
            minWidth: 420,
            flex: 1.5,
            renderCell: (params) => {
                const potentialRefund = getNumericValue(params.row.potential_refund);
                const isNoRefund = params.row.settlement_recommendation === 'NO_REFUND';
                const hasRefundableAmount = potentialRefund > 0 || hasDepositToRefund(params.row.deposit_to_refund);

                return (
                    <Box sx={{display: 'flex', justifyContent: 'space-between', gap: 1}}>
                        {!hasDepositToRefund(params.row.deposit_to_refund) ? (
                            <Box sx={{display: 'flex', gap: 1}}>
                                <Button
                                    onClick={() => {
                                        //Opens refund modal
                                        setTenantDetails({
                                            tenant_id: params.id,
                                            tenant_name:
                                                params.row.first_name + " " + params.row.last_name,
                                            deposit_held: params.row.deposit_held,
                                        });

                                        // Try to parse expenses from XML first, then fall back to parsed object
                                        let expensesList = [];

                                        // First try XML parsing from deposit_expenses
                                        if (params.row.deposit_expenses && params.row.deposit_expenses !== '') {
                                            expensesList = parseDepositExpensesXml(params.row.deposit_expenses);
                                        }

                                        // Fall back to deposit_expenses_parsed if XML parsing returned empty
                                        if (expensesList.length === 0) {
                                            const parsedExpenses = params.row.deposit_expenses_parsed;
                                            if (parsedExpenses && typeof parsedExpenses === 'object' && Object.keys(parsedExpenses).length > 0) {
                                                expensesList = Object.entries(parsedExpenses).map(([desc, amt]) => ({
                                                    description: desc,
                                                    amount: amt
                                                }));
                                            }
                                        }

                                        if (expensesList.length > 0) {
                                            // Load existing saved expenses
                                            const newExpenseItem = new Map();
                                            expensesList.forEach((exp, idx) => {
                                                newExpenseItem.set("description " + (idx + 1), exp.description);
                                                newExpenseItem.set("value for description " + (idx + 1), exp.amount);
                                            });
                                            setExpenses([newExpenseItem]);
                                            setExpensesIncurred(expensesList.length + 1);
                                            setInputs(
                                                expensesList.map((expense, index) => (
                                                    <div key={index}>
                                                        <br/>
                                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                            <TextField
                                                                label="Description"
                                                                type="text"
                                                                variant="outlined"
                                                                name={"description " + (index + 1)}
                                                                defaultValue={expense.description}
                                                                style={{ marginTop: "10px", width: "49%" }}
                                                                InputLabelProps={{ shrink: true }}
                                                                onChange={handleChange("property" + (index + 1))}
                                                            />
                                                            <TextField
                                                                label="Amount"
                                                                type="number"
                                                                variant="outlined"
                                                                name={"value for description " + (index + 1)}
                                                                defaultValue={expense.amount}
                                                                style={{ marginTop: "10px", width: "49%" }}
                                                                InputLabelProps={{ shrink: true }}
                                                                onChange={handleChange("property" + (index + 1))}
                                                            />
                                                        </div>
                                                    </div>
                                                ))
                                            );
                                        } else {
                                            // No existing expenses - pre-populate with outstanding balance if any
                                            const totalOutstanding = getNumericValue(params.row.total_outstanding);
                                            if (totalOutstanding > 0) {
                                                const newExpenseItem = new Map();
                                                newExpenseItem.set("description 1", "Outstanding Balance");
                                                newExpenseItem.set("value for description 1", totalOutstanding);
                                                setExpenses([newExpenseItem]);
                                                setExpensesIncurred(2);
                                                setInputs(
                                                    <div key={0}>
                                                        <br/>
                                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                            <TextField
                                                                label="Description"
                                                                type="text"
                                                                variant="outlined"
                                                                name="description 1"
                                                                defaultValue="Outstanding Balance"
                                                                style={{ marginTop: "10px", width: "49%" }}
                                                                InputLabelProps={{ shrink: true }}
                                                                onChange={handleChange("property1")}
                                                            />
                                                            <TextField
                                                                label="Amount"
                                                                type="number"
                                                                variant="outlined"
                                                                name="value for description 1"
                                                                defaultValue={totalOutstanding}
                                                                style={{ marginTop: "10px", width: "49%" }}
                                                                InputLabelProps={{ shrink: true }}
                                                                onChange={handleChange("property1")}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            } else {
                                                // No outstanding balance - start with empty form
                                                setExpenses([]);
                                                setExpensesIncurred(1);
                                                setInputs(<div></div>);
                                            }
                                        }

                                        setAddDepositExpenseModal(true);
                                    }}
                                    variant="outlined"
                                >
                                    Add Expenses
                                </Button>

                                {/* Show Refund button for tenants with potential refund (e.g., overpayment credit) */}
                                {potentialRefund > 0 && !isNoRefund && (
                                    <Button
                                        variant="contained"
                                        color="success"
                                        size="small"
                                        startIcon={<AccountBalanceWalletIcon/>}
                                        onClick={() => {
                                            setTenantDetails({
                                                tenant_id: params.id,
                                                tenant_name: params.row.first_name + " " + params.row.last_name,
                                                deposit_held: params.row.deposit_held,
                                            });

                                            const overpayment = getNumericValue(params.row.total_overpayment);

                                            setInitialPaymentValues({
                                                names: params.row.first_name + " " + params.row.last_name,
                                                tenant_id: params.row.tenant_id,
                                                expenses: params.row.deposit_expenses_parsed,
                                                deposit_held: params.row.deposit_held,
                                                amount: potentialRefund.toString(),
                                                overpayment: overpayment,
                                                phone_number: params.row.phone_number,
                                                secondary_phone_number: params.row.secondary_phone_number,
                                                property_id: params.row.property_id,
                                                house_number: params.row.house_number,
                                                account_number: params.row.account_number
                                            });

                                            setInitialPaymentsDetails(true);
                                            setRefundModal(true);
                                        }}
                                    >
                                        Refund ({formatCurrency(potentialRefund)})
                                    </Button>
                                )}
                            </Box>
                        ) : (
                            <Box sx={{display: 'flex', gap: 1}}>
                                <Button
                                    variant="outlined"
                                    color="success"
                                    size="small"
                                    startIcon={<AccountBalanceWalletIcon/>}
                                    onClick={() => {
                                        // Opens refund modal
                                        setTenantDetails({
                                            tenant_id: params.id,
                                            tenant_name: params.row.first_name + " " + params.row.last_name,
                                            deposit_held: params.row.deposit_held,
                                        });

                                        // Use deposit_to_refund if set, otherwise potential_refund
                                        const refundAmount = hasDepositToRefund(params.row.deposit_to_refund)
                                            ? getNumericValue(params.row.deposit_to_refund)
                                            : getNumericValue(params.row.potential_refund);

                                        setInitialPaymentValues({
                                            names: params.row.first_name + " " + params.row.last_name,
                                            tenant_id: params.row.tenant_id,
                                            expenses: params.row.deposit_expenses_parsed,
                                            deposit_held: params.row.deposit_held,
                                            amount: refundAmount.toString(),
                                            phone_number: params.row.phone_number,
                                            secondary_phone_number: params.row.secondary_phone_number,
                                            property_id: params.row.property_id,
                                            house_number: params.row.house_number,
                                            account_number: params.row.account_number
                                        });

                                        setInitialPaymentsDetails(true);
                                        setRefundModal(true);
                                    }}
                                >
                                    Refund Deposit
                                </Button>

                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<ReceiptLongIcon/>}
                                    onClick={() => {
                                        // Opens expense modal for editing
                                        setTenantDetails({
                                            tenant_id: params.id,
                                            tenant_name: params.row.first_name + " " + params.row.last_name,
                                            deposit_held: params.row.deposit_held,
                                        });

                                        // Try to parse expenses from XML first, then fall back to parsed object
                                        let expensesList = [];

                                        // First try XML parsing from deposit_expenses
                                        if (params.row.deposit_expenses && params.row.deposit_expenses !== '') {
                                            expensesList = parseDepositExpensesXml(params.row.deposit_expenses);
                                        }

                                        // Fall back to deposit_expenses_parsed if XML parsing returned empty
                                        if (expensesList.length === 0) {
                                            const parsedExpenses = params.row.deposit_expenses_parsed;
                                            if (parsedExpenses && typeof parsedExpenses === 'object' && Object.keys(parsedExpenses).length > 0) {
                                                expensesList = Object.entries(parsedExpenses).map(([desc, amt]) => ({
                                                    description: desc,
                                                    amount: amt
                                                }));
                                            }
                                        }

                                        if (expensesList.length > 0) {
                                            // Create expense Map for calculations
                                            const newExpenseItem = new Map();
                                            expensesList.forEach((exp, idx) => {
                                                newExpenseItem.set("description " + (idx + 1), exp.description);
                                                newExpenseItem.set("value for description " + (idx + 1), exp.amount);
                                            });
                                            setExpenses([newExpenseItem]);
                                            setExpensesIncurred(expensesList.length + 1);

                                            setInputs(
                                                expensesList.map((expense, index) => (
                                                    <div key={index}>
                                                        <br/>
                                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                            <TextField
                                                                label="Description"
                                                                type="text"
                                                                variant="outlined"
                                                                name={"description " + (index + 1)}
                                                                defaultValue={expense.description}
                                                                style={{ marginTop: "10px", width: "49%" }}
                                                                InputLabelProps={{ shrink: true }}
                                                                onChange={handleChange("property" + (index + 1))}
                                                            />
                                                            <TextField
                                                                label="Amount"
                                                                type="number"
                                                                variant="outlined"
                                                                name={"value for description " + (index + 1)}
                                                                defaultValue={expense.amount}
                                                                style={{ marginTop: "10px", width: "49%" }}
                                                                InputLabelProps={{ shrink: true }}
                                                                onChange={handleChange("property" + (index + 1))}
                                                            />
                                                        </div>
                                                    </div>
                                                ))
                                            );
                                        } else {
                                            setExpenses([]);
                                            setExpensesIncurred(1);
                                            setInputs(<div></div>);
                                        }

                                        setAddDepositExpenseModal(true);
                                    }}
                                >
                                    Edit Expenses
                                </Button>

                                <Tooltip title="View Tenant Details">
                                    <Button
                                        variant="outlined"
                                        color="info"
                                        size="small"
                                        startIcon={<InfoIcon/>}
                                        onClick={() => {
                                            navigate("/tenant/" + params.row.tenant_id, {
                                                state: {
                                                    tenant_id: params.row.tenant_id,
                                                    property_id: params.row.property_id,
                                                    isVacated: true,
                                                    vacatingDetails: {
                                                        date_to_vacate: params.row.date_to_vacate_house,
                                                        reasons: params.row.reasons_for_vacating,
                                                        deposit_held: params.row.deposit_held,
                                                        deposit_to_refund: params.row.deposit_to_refund,
                                                    }
                                                },
                                            });
                                        }}
                                    >
                                        Details
                                    </Button>
                                </Tooltip>
                            </Box>
                        )}

                        <Button
                            variant="outlined"
                            color="warning"
                            size="small"
                            startIcon={<DescriptionOutlined/>}
                            onClick={() => {
                                // Opens vacating notice modal
                                setNoticeDetails({
                                    last_name: params.row.last_name,
                                    first_name: params.row.first_name,
                                    date_notice_given: params.row.date_created,
                                    deposit_held: params.row.deposit_held,
                                    date_to_vacate_house: params.row.date_to_vacate_house,
                                    reasons_for_vacating: params.row.reasons_for_vacating,
                                });
                                setDataSet(true);
                                setVacatingModal(true);
                            }}
                        >
                            View Notice
                        </Button>

                        <Button
                            variant="outlined"
                            color="success"
                            size="small"
                            startIcon={<Restore/>}
                            onClick={() => {
                                setRestoreTenantDetails({
                                    property_id: params.row.property_id,
                                    tenant_id: params.row.tenant_id,
                                    house_number: params.row.house_number,
                                    name: params.row.first_name + " " + params.row.last_name,
                                });
                                setDeleteModal(true);
                            }}
                        >
                            Restore
                        </Button>
                    </Box>
                );
            },
        },
    ];
    return (<>
            {backDrop}

            {/* Restore Tenant Modal */}
            <StyledDialog
                open={deleteModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogHeaderStyled>
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1}}>
                        <Restore sx={{color: '#4caf50'}}/>
                        <Typography variant="h6">Restore Tenant</Typography>
                    </Box>
                </DialogHeaderStyled>

                <DialogContent>
                    <Box sx={{textAlign: 'center', mb: 3}}>
                        <Avatar
                            sx={{
                                width: 64,
                                height: 64,
                                bgcolor: '#e8f5e9',
                                color: '#4caf50',
                                margin: '0 auto 16px'
                            }}
                        >
                            <PersonIcon fontSize="large"/>
                        </Avatar>
                        <Typography variant="h6">{restoreTenantDetails.name}</Typography>
                        <Chip
                            label={`House ${restoreTenantDetails.house_number}`}
                            size="small"
                            sx={{mt: 1}}
                        />
                    </Box>

                    <Alert severity="info" sx={{mb: 3}}>
                        Restoring this tenant will return them and their documents back to the system and mark their
                        house as occupied.
                    </Alert>

                    <Typography variant="subtitle1" align="center" fontWeight={500}>
                        Are you sure you want to restore this tenant?
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button
                        variant="outlined"
                        color="inherit"
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        variant="contained"
                        color="success"
                        onClick={restoreTenant}
                        loading={loading}
                        startIcon={<Restore/>}
                        loadingPosition="start"
                    >
                        Restore Tenant
                    </LoadingButton>
                </DialogActions>
            </StyledDialog>

            {/* Refund Modal */}
            <StyledDialog
                open={refundModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogHeaderStyled>
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1}}>
                        <AccountBalanceWalletIcon sx={{color: '#4caf50'}}/>
                        <Typography variant="h6">Refund Deposit</Typography>
                    </Box>
                </DialogHeaderStyled>

                <DialogContent>
                    <Box sx={{textAlign: 'center', mb: 3}}>
                        <Avatar
                            sx={{
                                width: 64,
                                height: 64,
                                bgcolor: '#e8f5e9',
                                color: '#4caf50',
                                margin: '0 auto 16px'
                            }}
                        >
                            <PersonIcon fontSize="large"/>
                        </Avatar>
                        <Typography variant="h6">{tenantDetails.tenant_name}</Typography>
                    </Box>

                    {initialPaymentsDetails ? (
                        <Formik
                            initialValues={initialPaymentValues}
                            validationSchema={basicSchema}
                            onSubmit={processPayment}
                            enableReinitialize={true}
                        >
                            {(props) => (
                                <Form noValidate>
                                    <FormField>
                                        <Typography variant="subtitle2" gutterBottom>
                                            Enter the phone number to send payment to:
                                        </Typography>
                                        <br/>
                                        <Field
                                            as={TextField}
                                            name="phone_number"
                                            label="Phone Number"
                                            error={props.errors.phone_number && props.touched.phone_number}
                                            helperText={<ErrorMessage name="phone_number" component="div"
                                                                      className="error"/>}
                                            required
                                            variant="outlined"
                                            fullWidth
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                            <Box
                                                                component="img"
                                                                src="https://flagcdn.com/w20/ke.png"
                                                                alt="Kenya"
                                                                sx={{
                                                                    width: 20,
                                                                    height: 'auto',
                                                                    borderRadius: '2px',
                                                                    boxShadow: '0 1px 2px rgba(0,0,0,0.2)'
                                                                }}
                                                            />
                                                            <Typography variant="body2" sx={{
                                                                fontSize: '0.85rem',
                                                                color: 'text.secondary'
                                                            }}>
                                                                +254
                                                            </Typography>
                                                        </Box>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </FormField>

                                    <FormField>
                                        <Field
                                            as={TextField}
                                            name="amount"
                                            label="Amount to Refund"
                                            type="number"
                                            required
                                            variant="outlined"
                                            error={props.errors.amount && props.touched.amount}
                                            helperText={<ErrorMessage name="amount" component="div" className="error"/>}
                                            fullWidth
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">KSH</InputAdornment>
                                                ),
                                            }}
                                        />
                                    </FormField>

                                    <Alert severity="warning" sx={{mb: 2}}>
                                        <Typography variant="body2" fontWeight={500}>
                                            Please confirm the phone number before proceeding!
                                        </Typography>
                                    </Alert>

                                    <Box sx={{display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3}}>
                                        <Button
                                            variant="outlined"
                                            color="inherit"
                                            onClick={handleClose}
                                        >
                                            Cancel
                                        </Button>

                                        {(parseInt(initialPaymentValues.amount) !== 0 && parseInt(initialPaymentValues.amount) > 0) && (
                                            <LoadingButton
                                                variant="outlined"
                                                color="info"
                                                onClick={() => processDepositAsIncome(initialPaymentValues)}
                                                loading={tenantLoading}
                                                startIcon={<MoneyOffIcon/>}
                                                loadingPosition="start"
                                            >
                                                Mark as Income
                                            </LoadingButton>
                                        )}

                                        <LoadingButton
                                            variant="contained"
                                            color="success"
                                            type={(parseInt(initialPaymentValues.amount) <= 0) ? undefined : "submit"}
                                            loading={tenantLoading}
                                            startIcon={(parseInt(initialPaymentValues.amount) <= 0) ? <DeleteIcon/> :
                                                <SendIcon/>}
                                            loadingPosition="start"
                                        >
                                            {(parseInt(initialPaymentValues.amount) <= 0) ? 'Remove Tenant' : 'Process Refund'}
                                        </LoadingButton>
                                    </Box>
                                </Form>
                            )}
                        </Formik>
                    ) : null}
                </DialogContent>
            </StyledDialog>

            {/* Add Deposit Expense Modal */}
            <StyledDialog
                open={addDepositExpenseModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                maxWidth="md"
                fullWidth
            >
                <DialogHeaderStyled>
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1}}>
                        <ReceiptLongIcon sx={{color: '#f57c00'}}/>
                        <Typography variant="h6">Deposit Deductions for {tenantDetails.tenant_name}</Typography>
                    </Box>
                </DialogHeaderStyled>

                <DialogContent>
                    <Box sx={{mb: 3}}>
                        <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2}}>
                            <Typography variant="subtitle1" color="primary" fontWeight={500}>
                                Expenses to Deduct from Deposit
                            </Typography>
                            {/*<Button
                                variant="outlined"
                                color="primary"
                                startIcon={<AddIcon/>}
                                onClick={() => {
                                    setExpensesIncurred(expensesIncurred + 1);
                                    setInputs(
                                        [...Array(expensesIncurred)].map((_, index) => (
                                            <ExpenseRow key={index}>
                                                <TextField
                                                    label="Description"
                                                    type="text"
                                                    variant="outlined"
                                                    name={`description ${index + 1}`}
                                                    required
                                                    fullWidth
                                                    onChange={handleChange(`property${index + 1}`)}
                                                />
                                                <TextField
                                                    label="Amount"
                                                    type="number"
                                                    name={`value for description ${index + 1}`}
                                                    variant="outlined"
                                                    fullWidth
                                                    onChange={handleChange(`property${index + 1}`)}
                                                />
                                            </ExpenseRow>
                                        ))
                                    );
                                }}
                            >
                                Add Expense
                            </Button>*/}
                            <Button
                                variant="outlined"
                                color="primary"
                                startIcon={<AddIcon/>}
                                onClick={() => {

                                    setExpensesIncurred(expensesIncurred + 1);
                                    setInputs(
                                        [...Array(expensesIncurred)].map(
                                            (elementInArray, index) => (
                                                <div key={index}>
                                                    <br/>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                        }}
                                                    >
                                                        <TextField
                                                            label="Description"
                                                            type={"text"}
                                                            variant="outlined"
                                                            name={"description " + (index + 1)}
                                                            required
                                                            style={{marginTop: "10px", width: "49%"}}
                                                            onChange={handleChange("property" + (index + 1))}
                                                        />
                                                        <TextField
                                                            label="Amount"
                                                            type={"number"}
                                                            name={"value for description " + (index + 1)}
                                                            variant="outlined"
                                                            style={{marginTop: "10px", width: "49%"}}
                                                            onChange={handleChange("property" + (index + 1))}
                                                        />
                                                    </div>
                                                </div>
                                            )
                                        )
                                    );
                                }}
                            >
                                Add Expense
                            </Button>
                        </Box>

                        <Divider sx={{mb: 3}}/>

                        <Box sx={{mb: 3}}>{inputs}</Box>

                        <Box sx={{display: 'flex', justifyContent: 'flex-end', mb: 3}}>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<CalculateIcon/>}
                                onClick={calculateRefundableDeposit}
                            >
                                Calculate
                            </Button>
                        </Box>

                        <Box
                            sx={{
                                p: 3,
                                bgcolor: '#f5f5f5',
                                borderRadius: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2
                            }}
                        >
                            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <Typography variant="body1" color="primary" fontWeight={500}>
                                    Deposit Held:
                                </Typography>
                                <Typography variant="h6" fontWeight="bold">
                                    {parseFloat(tenantDetails.deposit_held.toString().replace(/,/g, '')).toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "KSH",
                                    })}
                                </Typography>
                            </Box>

                            <Divider/>

                            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <Typography variant="body1" color="primary" fontWeight={500}>
                                    Total Expenses:
                                </Typography>
                                <Typography variant="h6" fontWeight="bold">
                                    {totalExpenses}
                                </Typography>
                            </Box>

                            <Divider/>

                            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <Typography variant="body1" color="primary" fontWeight={500}>
                                    Deposit To Refund:
                                </Typography>
                                <Typography variant="h6" fontWeight="bold" color="#4caf50">
                                    {depositToRefund.toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "KSH",
                                    })}
                                </Typography>
                            </Box>

                            {lossIncurred > 0 && (
                                <>
                                    <Divider/>
                                    <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                        <Typography variant="body1" color="primary" fontWeight={500}>
                                            Loss Incurred:
                                        </Typography>
                                        <Typography variant="h6" fontWeight="bold" color="#f44336">
                                            {lossIncurred.toLocaleString("en-US", {
                                                style: "currency",
                                                currency: "KSH",
                                            })}
                                        </Typography>
                                    </Box>
                                </>
                            )}
                        </Box>
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button
                        variant="outlined"
                        color="inherit"
                        onClick={() => {
                            window.location.reload(false);
                            handleClose();
                        }}
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        variant="contained"
                        color="success"
                        onClick={handleRefundDeposit}
                        loading={loading}
                        startIcon={<SendIcon/>}
                        loadingPosition="start"
                    >
                        Confirm & Save
                    </LoadingButton>
                </DialogActions>
            </StyledDialog>

            {/* View Deposit Expenses Modal */}
            <StyledDialog
                open={moreInfoModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                maxWidth="md"
                fullWidth
            >
                <DialogHeaderStyled>
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1}}>
                        <InfoIcon sx={{color: '#1976d2'}}/>
                        <Typography variant="h6">Deposit Deduction Details</Typography>
                    </Box>
                </DialogHeaderStyled>

                <DialogContent>
                    <Typography variant="subtitle1" color="primary" fontWeight={500} gutterBottom>
                        Expenses Deducted from Deposit
                    </Typography>

                    <Divider sx={{mb: 3}}/>

                    <Box sx={{mb: 3}}>{depositExpenses}</Box>

                    <Box
                        sx={{
                            p: 3,
                            bgcolor: '#f5f5f5',
                            borderRadius: 2
                        }}
                    >
                        <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                            <Typography variant="body1" color="primary" fontWeight={500}>
                                Total Expenses:
                            </Typography>
                            <Typography variant="h6" fontWeight="bold">
                                {totalExpenses.toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "KSH",
                                })}
                            </Typography>
                        </Box>
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleClose}
                    >
                        Close
                    </Button>
                </DialogActions>
            </StyledDialog>

            {/* View Vacating Notice Modal */}
            <StyledDialog
                open={vacatingModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                maxWidth="md"
                fullWidth
            >
                <DialogHeaderStyled>
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1}}>
                        <EventNoteOutlined sx={{color: '#f57c00'}}/>
                        <Typography variant="h6">Vacating Notice Details</Typography>
                    </Box>
                </DialogHeaderStyled>

                <DialogContent>
                    <Alert severity="info" sx={{mb: 3}}>
                        <Typography variant="body2">
                            If the notice details are not clear, please refresh the page.
                        </Typography>
                    </Alert>

                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <StyledCard>
                                <StyledCardContent>
                                    <Typography variant="subtitle1" color="primary" fontWeight={500} gutterBottom>
                                        Tenant Information
                                    </Typography>

                                    <TextField
                                        label="First Name"
                                        variant="outlined"
                                        value={noticeDetails.first_name || ''}
                                        InputLabelProps={{shrink: true}}
                                        fullWidth
                                        margin="normal"
                                        disabled
                                    />

                                    <TextField
                                        label="Last Name"
                                        variant="outlined"
                                        value={noticeDetails.last_name || ''}
                                        InputLabelProps={{shrink: true}}
                                        fullWidth
                                        margin="normal"
                                        disabled
                                    />
                                </StyledCardContent>
                            </StyledCard>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <StyledCard>
                                <StyledCardContent>
                                    <Typography variant="subtitle1" color="primary" fontWeight={500} gutterBottom>
                                        Notice Information
                                    </Typography>

                                    <TextField
                                        label="Date Notice Given"
                                        variant="outlined"
                                        value={formatDate(noticeDetails.date_notice_given)}
                                        InputLabelProps={{shrink: true}}
                                        fullWidth
                                        margin="normal"
                                        disabled
                                    />

                                    <TextField
                                        label="Date To Vacate"
                                        variant="outlined"
                                        value={formatDate(noticeDetails.date_to_vacate_house)}
                                        InputLabelProps={{shrink: true}}
                                        fullWidth
                                        margin="normal"
                                        disabled
                                    />
                                </StyledCardContent>
                            </StyledCard>
                        </Grid>

                        <Grid item xs={12}>
                            <StyledCard>
                                <StyledCardContent>
                                    <Typography variant="subtitle1" color="primary" fontWeight={500} gutterBottom>
                                        Reasons for Vacating
                                    </Typography>

                                    <Box sx={{mt: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 1}}>
                                        {dataSet && noticeDetails.reasons_for_vacating && (() => {
                                            // Try to parse as Draft.js JSON, otherwise render as HTML
                                            try {
                                                const parsed = JSON.parse(noticeDetails.reasons_for_vacating);
                                                // Check if it's a valid Draft.js content structure
                                                if (parsed && parsed.blocks) {
                                                    return (
                                                        <NonEditableRichTextEditor
                                                            richTextValue={EditorState.createWithContent(
                                                                convertFromRaw(parsed)
                                                            )}
                                                        />
                                                    );
                                                }
                                                // If parsed but not Draft.js format, render as text
                                                return <Typography variant="body2">{noticeDetails.reasons_for_vacating}</Typography>;
                                            } catch (e) {
                                                // If JSON parse fails, it's likely HTML or plain text
                                                return (
                                                    <Box
                                                        dangerouslySetInnerHTML={{
                                                            __html: noticeDetails.reasons_for_vacating
                                                        }}
                                                    />
                                                );
                                            }
                                        })()}
                                    </Box>
                                </StyledCardContent>
                            </StyledCard>
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleClose}
                        startIcon={<ArrowBackIosNewOutlined/>}
                    >
                        Back to List
                    </Button>
                </DialogActions>
            </StyledDialog>

            {/* Main Content */}
            <Box sx={{
                p: 3,
                bgcolor: '#ffffff',
                borderRadius: 2,
                boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
            }}>
                {/* Page Header */}
                <PageHeader>
                    <Typography variant="h5" fontWeight="600" color="primary">
                        Vacating Tenants Management
                    </Typography>

                    <Box sx={{display: 'flex'}}>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<RefreshIcon/>}
                            onClick={fetchVacatingTenants}
                            disabled={refreshing}
                        >
                            {refreshing ? 'Refreshing...' : 'Refresh List'}
                        </Button>
                    </Box>
                </PageHeader>

                {/* Search Bar */}
                <Box sx={{mb: 3}}>
                    <SearchBox elevation={0}>
                        <SearchIcon sx={{color: 'action.active', mr: 1, ml: 1}}/>
                        <InputBase
                            placeholder="Search by tenant name, property or house number..."
                            fullWidth
                            value={searchTerm}
                            onChange={handleSearch}
                        />
                    </SearchBox>
                </Box>

                {/* Statistics Summary */}
                <Grid container spacing={3} sx={{mb: 3}}>
                    <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard bgColor="#e3f2fd" textColor="#1976d2">
                            <Box sx={{mr: 2}}>
                                <Avatar sx={{bgcolor: 'white'}}>
                                    <PersonIcon sx={{color: '#1976d2'}}/>
                                </Avatar>
                            </Box>
                            <Box>
                                <Typography variant="h4" fontWeight="bold">
                                    {totalTenants}
                                </Typography>
                                <Typography variant="body2">
                                    Total Vacating Tenants
                                </Typography>
                            </Box>
                        </SummaryCard>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard bgColor="#e8f5e9" textColor="#4caf50">
                            <Box sx={{mr: 2}}>
                                <Avatar sx={{bgcolor: 'white'}}>
                                    <AccountBalanceWalletIcon sx={{color: '#4caf50'}}/>
                                </Avatar>
                            </Box>
                            <Box>
                                <Typography variant="h4" fontWeight="bold">
                                    {tenantsWithRefundableDeposit}
                                </Typography>
                                <Typography variant="body2">
                                    Ready for Refund
                                </Typography>
                            </Box>
                        </SummaryCard>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard bgColor="#fff8e1" textColor="#f57c00">
                            <Box sx={{mr: 2}}>
                                <Avatar sx={{bgcolor: 'white'}}>
                                    <WarningAmberOutlined sx={{color: '#f57c00'}}/>
                                </Avatar>
                            </Box>
                            <Box>
                                <Typography variant="h4" fontWeight="bold">
                                    {tenantsWithoutRefundableDeposit}
                                </Typography>
                                <Typography variant="body2">
                                    Pending Expense Entry
                                </Typography>
                            </Box>
                        </SummaryCard>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard bgColor="#f3e5f5" textColor="#9c27b0">
                            <Box sx={{mr: 2}}>
                                <Avatar sx={{bgcolor: 'white'}}>
                                    <ReceiptLongIcon sx={{color: '#9c27b0'}}/>
                                </Avatar>
                            </Box>
                            <Box>
                                <Typography variant="h6" fontWeight="bold">
                                    {totalDepositToRefund.toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "KSH",
                                    })}
                                </Typography>
                                <Typography variant="body2">
                                    Total Amount to Refund
                                </Typography>
                            </Box>
                        </SummaryCard>
                    </Grid>
                </Grid>

                {/* Vacating Tenants Table */}
                {searchResults.length === 0 ? (
                    <Box sx={{
                        p: 5,
                        textAlign: 'center',
                        bgcolor: '#f5f5f5',
                        borderRadius: 2
                    }}>
                        <Typography variant="h6" color="text.secondary" gutterBottom>
                            No vacating tenants found
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {searchTerm ? 'Try adjusting your search criteria' : 'All tenants are currently active'}
                        </Typography>
                    </Box>
                ) : (
                    <Box sx={{height: 'calc(100vh - 350px)', width: '100%'}}>
                        <StyledDataGrid
                            rows={searchResults}
                            columns={columns}
                            disableSelectionOnClick
                            pageSize={10}
                            rowsPerPageOptions={[5, 10, 25]}
                            loading={refreshing}
                            getRowClassName={(params) => params.row.state === "NOTICE" ? "notice-row" : ""}
                            /*onRowClick={(params) => {
                                navigate("/tenant/" + params.row.tenant_id, {
                                    state: {
                                        tenant_id: params.row.tenant_id,
                                        property_id: params.row.property_id,
                                        isVacated: true,
                                        vacatingDetails: {
                                            date_to_vacate: params.row.date_to_vacate_house,
                                            reasons: params.row.reasons_for_vacating,
                                            deposit_held: params.row.deposit_held,
                                            deposit_to_refund: params.row.deposit_to_refund,
                                        }
                                    },
                                });
                            }}*/
                            initialState={{
                                sorting: {
                                    sortModel: [{field: 'deposit_to_refund', sort: 'asc'}],
                                },
                            }}
                            sx={{
                                '& .MuiDataGrid-virtualScroller': {
                                    overflow: 'auto',
                                },
                                border: 'none',
                                '& .MuiDataGrid-row': {
                                    cursor: 'pointer',
                                },
                            }}
                        />
                    </Box>
                )}
            </Box>
        </>
    )
};